import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  CmsConfig,
  ConfigModule,
  I18nModule
} from '@spartacus/core';
import {
  RecaptchaFormsModule,
  RecaptchaModule
} from 'ng-recaptcha';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { RecaptchaService } from '../shared/services/recaptcha.service';
import { AccountConfirmationInformationComponent } from './account-registration/account-confirmation-information/account-confirmation-information.component';
import { AccountHeaderComponent } from './account-registration/account-header/account-header.component';
import { AccountRegistrationComponent } from './account-registration/account-registration.component';
import { BillingInformationComponent } from './account-registration/billing-information/billing-information.component';
import { ContactsInformationComponent } from './account-registration/contacts-information/contacts-information.component';
import { PhoneMaskDirective } from './account-registration/phone-mask.directive';
import { ShippingInformationComponent } from './account-registration/shipping-information/shipping-information.component';
import { AccountInformationComponent } from './user-registration/account-information/account-information.component';
import { UserConfirmationComponent } from './user-registration/user-confirmation/user-confirmation.component';
import { UserHeaderComponent } from './user-registration/user-header/user-header.component';
import { UserInformationComponent } from './user-registration/user-information/user-information.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { ZipMaskDirective } from './user-registration/zip-mask.directive';

const startIndex = 6;
const totalCharsNeeded = 2;
const language = location.pathname.substr(startIndex, totalCharsNeeded);

export function loadRecaptcha(recaptchaService: RecaptchaService): () => Promise<void> {
  return () => recaptchaService.loadRecaptchaConfig();
}
@NgModule({
  declarations: [
    AccountRegistrationComponent,
    UserRegistrationComponent,
    BillingInformationComponent,
    ShippingInformationComponent,
    ContactsInformationComponent,
    AccountConfirmationInformationComponent,
    AccountHeaderComponent,
    PhoneMaskDirective,
    AccountInformationComponent,
    UserInformationComponent,
    UserHeaderComponent,
    UserConfirmationComponent,
    ZipMaskDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NeedAssistanceModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FluDashboardBannerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        RegistrationPageComponent: {
          component: () =>
            import(
              './account-registration/account-registration.component'
            ).then((m) => m.AccountRegistrationComponent),
        },
        CustomerRegistrationPageComponent: {
          component: () =>
            import('./user-registration/user-registration.component').then(
              (m) => m.UserRegistrationComponent
            ),
        },
        UserRegistrationPageComponent: {
          component: () =>
            import(
              './user-registration/user-confirmation/user-confirmation.component'
            ).then((m) => m.UserConfirmationComponent),
        },
        AccountRegistrationPageComponent: {
          component: () =>
            import(
              './account-registration/account-confirmation-information/account-confirmation-information.component'
            ).then((m) => m.AccountConfirmationInformationComponent),
        },
      },
      i18n: {
        backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' },
      },
      chunks: translationChunksConfig,
    } as CmsConfig),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [RecaptchaService],
      useFactory: loadRecaptcha,
      multi: true,
    }
  ],
  exports: [PhoneMaskDirective, ZipMaskDirective],
})
export class CustomUserRegistrationModule { }
